/*
 * @Author: zhenglfsir@gmail.com
 * @Date: 2018-09-10 15:14:00
 * @Last Modified by: zhenglfsir@gmail.com
 * @Last Modified time: 2019-04-28 10:01:03
 */
export const isDev = () =>
  process.env.NODE_ENV !== 'production' || process.env.API_ENV === 'development';

export const isMC = () => process.env.APP_TYPE === 'mc';

export const isMini = () => process.env.APP_TYPE === 'mini';

export const isApiEnvTest = () => process.env.API_ENV === 'test';

export const isProd = () =>
  process.env.NODE_ENV === 'production' && process.env.API_ENV === 'production';
